module.exports = __webpack_public_path__ + "img/book-head.45baa4b1.png";